import { FaCalendarCheck, FaUserCheck, FaClock, FaMapMarkerAlt } from 'react-icons/fa';

const counter = [
    {
        id: 1,
        icon: <FaCalendarCheck />, // Calendar check icon for events held
        title: 'Events Held',
        count: '150',
    },
    {
        id: 2,
        icon: <FaUserCheck />, // User check icon for happy attendees
        title: 'Happy Attendees',
        count: '5000',
    },
    {
        id: 3,
        icon: <FaClock />, // Clock icon for years in operation
        title: 'Years in Operation',
        count: '5',
    },
    {
        id: 4,
        icon: <FaMapMarkerAlt />, // Map marker icon for cities hosted
        title: 'Cities Hosted',
        count: '20',
    },
];

export default counter;